export interface ApplianceTitles {
  airConditioner1hpTitle: string;
  airConditioner15hpTitle: string;
  airConditioner2hpTitle: string;
  airFryerTitle: string;
  blenderTitle: string;
  ceilingFanTitle: string;
  decoderTitle: string;
  deepFreezerTitle: string;
  desktopComputerTitle: string;
  electricCookerTitle: string;
  electricIronTitle: string;
  electricKettleTitle: string;
  energySavingBulbTitle: string;
  flourescentTubeTitle: string;
  homeTheatreTitle: string;
  incandescentBulbTitle: string;
  laptopTitle: string;
  ledBulbTitle: string;
  microwaveOvenTitle: string;
  printerTitle: string;
  refrigeratorTitle: string;
  standingFanTitle: string;
  televisionTitle: string;
  toasterTitle: string;
  vacuumCleanerTitle: string;
  washingMachineTitle: string;
  waterHeaterTitle: string;
  waterPump05hpTitle: string;
  waterPump1hpTitle: string;
  otherTitle: string;
}

export function buildApplianceOptions(titles: ApplianceTitles): string[] {
  return [
    titles.airConditioner1hpTitle,
    titles.airConditioner15hpTitle,
    titles.airConditioner2hpTitle,
    titles.airFryerTitle,
    titles.blenderTitle,
    titles.ceilingFanTitle,
    titles.decoderTitle,
    titles.deepFreezerTitle,
    titles.desktopComputerTitle,
    titles.electricCookerTitle,
    titles.electricIronTitle,
    titles.electricKettleTitle,
    titles.energySavingBulbTitle,
    titles.flourescentTubeTitle,
    titles.homeTheatreTitle,
    titles.incandescentBulbTitle,
    titles.laptopTitle,
    titles.ledBulbTitle,
    titles.microwaveOvenTitle,
    titles.printerTitle,
    titles.refrigeratorTitle,
    titles.standingFanTitle,
    titles.televisionTitle,
    titles.toasterTitle,
    titles.vacuumCleanerTitle,
    titles.washingMachineTitle,
    titles.waterHeaterTitle,
    titles.waterPump05hpTitle,
    titles.waterPump1hpTitle,
    titles.otherTitle,
  ];
}
